import { connect } from 'react-redux';
import ReusableTxOverviewTab from './ReusableTxOverviewTab';
import { isReadOnly } from '../../../lib/ACLUtils';
import { fetchTransformDoc, updateTransformDoc } from '../../../actions';
import { GET_TRANSFORM_DOC_REQUEST } from '../../../constants/actionTypes';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { docs },
    transforms: {
      docById,
      allTransforms: { decoded },
    },
  } = state;
  const { data } = ownProps;
  const readOnly = isReadOnly(data);

  return {
    readOnly,
    data: {
      ...data,
      ...decoded[data.id],
    },
    doc: data && docById[data.id] && docs[docById[data.id]] ? docs[docById[data.id]].text : null,
    isLoadingDoc: !!request[GET_TRANSFORM_DOC_REQUEST],
  };
};

export default connect(mapStateToProps, {
  fetchTransformDoc,
  updateTransformDoc,
})(ReusableTxOverviewTab);
